import {Box, Colors, Text} from "@bounce/shared/ui";
import {InfoTooltip} from "./InfoTooltip";
import {TooltipRow} from "./TooltipRow";

type CioLinkHelp = {steps: string[]; note?: string};

const CIO_LINK_HELP: Record<"cio_studio" | "cio_regular", CioLinkHelp> = {
  cio_regular: {
    steps: [
      "Open the campaign in Customer.io.",
      "Go to the Workflow tab.",
      "Click the message action.",
      "Copy the URL - it looks like …/automations/<id>/workflow/actions?actionId=<id> and Paste it",
      "press Sync to pull the message content into this template",
    ],
  },
  cio_studio: {
    steps: [
      "Open the message in Design Studio.",
      "Copy the editor URL - it looks like …/design-studio/editor/<id> and Paste it",
      "then press Sync to pull the message content into this template.",
    ],
  },
};

const StepNumber = ({n}: {n: number}) => (
  <Box
    sx={{
      flexShrink: 0,
      width: 18,
      height: 18,
      mt: "1px",
      borderRadius: "50%",
      backgroundColor: Colors.blue._100,
      color: Colors.blue._800,
      fontSize: 11,
      fontWeight: 600,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    {n}
  </Box>
);

const CioLinkContent = ({help}: {help: CioLinkHelp}) => (
  <Box sx={{py: 0.25}}>
    <Box sx={{display: "flex", flexDirection: "column", gap: 1}}>
      {help.steps.map((step, i) => (
        <TooltipRow key={i} marker={<StepNumber n={i + 1} />}>
          {step}
        </TooltipRow>
      ))}
    </Box>
    <Text size={12} sx={{color: Colors.grey._600, mt: 1, lineHeight: 1.4, display: "block"}}>
      {help.note}
    </Text>
  </Box>
);

export const CioLinkInfoTooltip = ({source}: {source: string}) => (
  <InfoTooltip content={<CioLinkContent help={source === "cio_studio" ? CIO_LINK_HELP.cio_studio : CIO_LINK_HELP.cio_regular} />} />
);
